import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://aaairrigationservice.com/#business",
  "name": "AAA Irrigation Service",
  "alternateName": "AAA Irrigation",
  "description": "TCEQ licensed irrigation repair and sprinkler system services in Allen, Plano, Frisco, McKinney and North Texas. License LI0016993.",
  "url": "https://aaairrigationservice.com",
  "telephone": "+14697513567",
  "email": "info@aaairrigationservice.com",
  "foundingDate": "2005",
  "logo": "https://aaairrigationservice.com/header_new.webp",
  "image": "https://aaairrigationservice.com/sprinklers.webp",
  "priceRange": "$$",
  "currenciesAccepted": "USD",
  "paymentAccepted": "Cash, Credit Card, Check",
  "hasMap": "https://maps.google.com/?q=AAA+Irrigation+Service+Allen+TX",
  "areaServed": [
    { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Richardson", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Murphy", "containedInPlace": { "@type": "State", "name": "Texas" } },
    { "@type": "City", "name": "Wylie", "containedInPlace": { "@type": "State", "name": "Texas" } }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Allen",
    "addressRegion": "TX",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "33.1032",
    "longitude": "-96.6706"
  },
  "openingHoursSpecification": [
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "18:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "08:00", "closes": "16:00" }
  ],
  "sameAs": [
    "https://www.facebook.com/aaairrigationservice",
    "https://www.google.com/maps/place/AAA+Irrigation+Service"
  ],
  "hasCredential": {
    "@type": "EducationalOccupationalCredential",
    "credentialCategory": "license",
    "name": "TCEQ Irrigation License LI0016993",
    "recognizedBy": { "@type": "Organization", "name": "Texas Commission on Environmental Quality" }
  },
  "serviceType": [
    "Sprinkler Repair", "Irrigation Repair", "Valve Repair", "Sprinkler Head Repair",
    "Controller Repair", "Leak Detection", "Pressure Testing", "Commercial Irrigation",
    "HOA Irrigation", "Emergency Sprinkler Repair"
  ]
};

const SERVICE_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Sprinkler Repair",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Expert sprinkler system repair including heads, valves, pipes, controllers, and leak detection. TCEQ Licensed LI0016993. Same-day service available.",
    "offers": { "@type": "Offer", "priceSpecification": { "@type": "PriceSpecification", "priceCurrency": "USD" } }
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Backflow Preventer Installation",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Backflow preventer installation and testing coordination for residential and commercial irrigation systems. Collin County compliant."
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Commercial Irrigation Maintenance",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "Comprehensive irrigation maintenance programs for commercial properties, HOAs, and office parks. Monthly and quarterly service plans available."
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Emergency Sprinkler Repair",
    "provider": { "@id": "https://aaairrigationservice.com/#business" },
    "areaServed": [
      { "@type": "City", "name": "Allen", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Plano", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "Frisco", "containedInPlace": { "@type": "State", "name": "Texas" } },
      { "@type": "City", "name": "McKinney", "containedInPlace": { "@type": "State", "name": "Texas" } }
    ],
    "description": "After-hours emergency irrigation repair for major leaks, broken main lines, and system failures. Priority response to prevent water damage."
  }
];

/**
 * SEO component — sets document title, meta description, keywords,
 * canonical URL, Open Graph tags, and LocalBusiness schema for each page.
 */
export const SEO = ({ title, description, keywords, canonical }) => {
  const location = useLocation();
  const baseUrl = 'https://aaairrigationservice.com';
  const canonicalUrl = canonical || `${baseUrl}${location.pathname}`;

  useEffect(() => {
    document.title = title;

    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    if (keywords) setMeta('name', 'keywords', keywords);

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', 'https://aaairrigationservice.com/sprinklers.webp');

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    // LocalBusiness schema — inject once, update @id per page
    let schema = document.getElementById('lb-schema');
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'lb-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({ ...LOCAL_BUSINESS_SCHEMA, "@id": canonicalUrl + "#business" });

    // Service schema — inject once on homepage
    if (location.pathname === '/') {
      let svcSchema = document.getElementById('svc-schema');
      if (!svcSchema) {
        svcSchema = document.createElement('script');
        svcSchema.id = 'svc-schema';
        svcSchema.type = 'application/ld+json';
        document.head.appendChild(svcSchema);
      }
      svcSchema.textContent = JSON.stringify(SERVICE_SCHEMA);
    }

  }, [title, description, keywords, canonicalUrl]);

  return null;
};
